import { i18n } from '@/plugins/i18n';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';
import { ratings } from '@/utils/meeting-utils';


/**
 * Score according to meetings ratings
 */
export default new VitalityCriterion({
  titleTr: 'VH_M_RATING',
  key: 'meetingRating',
  weight: 2,

  score: ({ meetings }, range) => {
    // Filter according to the period
    const filtered = meetings.filter(m => range.start.isBefore(m.date) && range.end.isAfter(m.date));
    const nMeetings = filtered.length;
    let totalScore = 0;
    let nRatings = 0;
    for (let i = 0; i < nMeetings; i++) {
      const { rating } = filtered[i];
      if (rating > 0) {
        nRatings++;
        totalScore += rating;
      }
    }

    const noPlannings = nMeetings === 0;
    totalScore = nRatings === 0 ? 0 : totalScore / nRatings;
    const score = noPlannings ? 0 : (totalScore * 100 / 4);

    return {
      score,
      data: {
        value: totalScore,
        noTopsFlops: noPlannings,
        noCategoryHint: noPlannings,
        noPlannings,
        nRatings,
      },
    };
  },

  text: ({ value, noPlannings, nRatings }) => {
    if (noPlannings) {
      return i18n.t('message.VH_M_NO_MEETING');
    }
    if (nRatings === 0) {
      return i18n.t('message.VH_M_NO_RATINGS');
    }
    const closest = Math.round(value);
    const rating = ratings.find(r => closest === r.rating);
    const ratingText = i18n.t(rating.textTr);

    return i18n.t('message.VH_M_RATING_TEXT', { value: value.sToFixed(1), scoreClosest: ratingText });
  },

});
